import { Link } from 'react-router-dom';
import type { BlogKnowledgeLink } from '@/mocks/blogKnowledgeLinks';

interface KnowledgeLinkBoxProps {
  link: BlogKnowledgeLink;
}

export default function KnowledgeLinkBox({ link }: KnowledgeLinkBoxProps) {
  return (
    <div className="mt-10 rounded-xl border border-royal-navy/40 bg-royal-navy/10 p-6 md:p-7">
      <p className="text-champagne-gold text-[11px] font-semibold tracking-[0.18em] uppercase mb-2">
        From the Knowledge Hub
      </p>
      <h2
        className="text-xl md:text-2xl font-semibold text-warm-white mb-2 leading-snug"
        style={{ fontFamily: "'Playfair Display', serif" }}
      >
        {link.heading}
      </h2>
      <p className="text-silver-grey text-sm leading-relaxed mb-5">{link.blurb}</p>

      <ul className="space-y-2.5 mb-6">
        {link.questions.map((question) => (
          <li key={question.n}>
            <Link
              to={`/knowledge#q-${question.n}`}
              className="group flex items-start gap-2.5 text-sm text-silver-grey hover:text-champagne-gold transition-colors duration-300 cursor-pointer"
            >
              <span className="shrink-0 w-4 h-4 mt-0.5 flex items-center justify-center text-champagne-gold/70 group-hover:text-champagne-gold">
                <i className="ri-arrow-right-line text-sm" />
              </span>
              <span className="leading-relaxed underline-offset-4 decoration-champagne-gold/40 group-hover:underline">
                {question.label}
              </span>
            </Link>
          </li>
        ))}
      </ul>

      <div className="flex flex-wrap items-center gap-3">
        <Link
          to={`/knowledge#${link.topicId}`}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-royal-navy/50 bg-royal-navy/20 text-silver-grey hover:text-champagne-gold hover:border-champagne-gold/60 transition-colors duration-300 text-xs md:text-sm whitespace-nowrap cursor-pointer"
        >
          {link.topicLabel}
          <i className="ri-hashtag text-xs" />
        </Link>
        <Link
          to="/knowledge"
          className="inline-flex items-center gap-2 text-champagne-gold text-xs md:text-sm font-medium hover:opacity-80 transition-opacity duration-300 whitespace-nowrap cursor-pointer"
        >
          Browse all 40 answers
          <i className="ri-arrow-right-up-line text-sm" />
        </Link>
      </div>
    </div>
  );
}